import { useEffect, useState } from "react";
import Vapi from "@vapi-ai/web";
import { useSearchParams } from "react-router-dom";

import ActiveCallDetail from "../components/ActiveCallDetail";
import Button from "../components/base/Button";
import { isPublicKeyMissingError } from "../utils";
import logo from "../assests/images/transperant-logo.png";

const vapi = new Vapi(process.env.REACT_APP_VAPI_PUBLIC_API_KEY);

const Rastaurant = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const assistan_id = searchParams.get("assistant_id");
  const [connecting, setConnecting] = useState(false);
  const [connected, setConnected] = useState(false);

  const [assistantIsSpeaking, setAssistantIsSpeaking] = useState(false);
  const [volumeLevel, setVolumeLevel] = useState(0);

  const { showPublicKeyInvalidMessage, setShowPublicKeyInvalidMessage } = usePublicKeyInvalid();

  useEffect(() => {
    getMicrophonePermission();
    vapi.on("call-start", () => {
      setConnecting(false);
      setConnected(true);

      setShowPublicKeyInvalidMessage(false);
    });

    vapi.on("call-end", () => {
      setConnecting(false);
      setConnected(false);

      setShowPublicKeyInvalidMessage(false);
    });

    vapi.on("speech-start", () => {
      setAssistantIsSpeaking(true);
    });

    vapi.on("speech-end", () => {
      setAssistantIsSpeaking(false);
    });

    vapi.on("volume-level", (level) => {
      setVolumeLevel(level);
    });

    vapi.on("error", (error) => {
      console.error(error);

      setConnecting(false);
      if (isPublicKeyMissingError({ vapiError: error })) {
        setShowPublicKeyInvalidMessage(true);
      }
    });
  }, []);

  const getMicrophonePermission = async () => {
    if ("MediaRecorder" in window) {
      try {
        const streamData = await navigator.mediaDevices.getUserMedia({
          audio: {
            noiseSuppression: true,
          },
          video: false,
        });
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
      } catch (err) {
        alert(err.message);
      }
    } else {
      alert("The MediaRecorder API is not supported in your browser.");
    }
  };

  const startCallInline = () => {
    setConnecting(true);
    vapi.start(assistan_id);
    setTimeout(() => {
      endCall();
    }, Number(process.env.REACT_APP_VAPI_END_CALL_TIME) * 1000 * 60);
  };
  const endCall = () => {
    vapi.stop();
  };

  return (
    <div className="w-screen flex flex-col h-[inherit] relative after:h-full after:w-full after:bg-no-repeat after:bg-cover after:bg-[url('./assests/images/body-bg.png')] after:absolute after:top-0 after:left-0 after:z-10">
      <header className="w-11/12 py-1.5 md:py-3 px-2 md:px-6 rounded-full relative z-50 mt-4 mx-auto block bg-[rgba(255,255,255,0.08)] border border-solid border-[rgba(255,255,255,0.08)]">
        <div className="flex items-center justify-between">
          <a href="/" className="block max-w-12 md:max-w-16">
            <img src={logo} className="max-w-full h-auto block" alt="logo" />
          </a>
          <a
            href="/"
            className="block text-sm sm:text-base text-white font-semibold md:text-lg bg-[rgba(255,255,255,0.05)] hover:bg-white hover:text-black border border-solid border-white rounded-full py-2 px-5 transition-all duration-200 ease-in"
          >
            Login
          </a>
        </div>
      </header>
      <section className="flex-grow flex flex-col justify-center items-center relative z-20 p-10">
        {assistan_id ? (
          <>
            <div className="flex flex-col justify-center items-center gap-20 text-center max-w-4xl">
              <div className="grid gap-2.5 text-center">
                <h1 className="text-3xl md:text-4xl lg:text-5xl 2xl:text-7xl 2xl:leading-tight font-semibold  inline-block text-white transition-all duration-200 ease-in">
                  Meet <span className="bg-gradient-to-r from-blue-600 via-green-500 to-indigo-400 text-transparent bg-clip-text">Myra</span> your AI
                  Waiter
                </h1>
                <p className="text-white text-sm md:text-base">
                  Tap the "Order Now" button to place your order with our intelligent Voice AI Waiter. Enjoy a seamless, contactless, and speedy
                  service without waiting.
                </p>
              </div>
              {!connected ? (
                <Button label="Order Now" onClick={startCallInline} isLoading={connecting} />
              ) : (
                <ActiveCallDetail assistantIsSpeaking={assistantIsSpeaking} volumeLevel={volumeLevel} onEndCallClick={endCall} />
              )}
            </div>
          </>
        ) : (
          <>
            <div className="grid gap-32 text-center max-w-4xl">
              <div className="grid gap-2.5">
                <h1 className="text-3xl md:text-4xl lg:text-5xl 2xl:text-7xl 2xl:leading-tight font-semibold bg-gradient-to-r from-blue-600 via-green-500 to-indigo-400 inline-block text-transparent bg-clip-text transition-all duration-200 ease-in">
                  Voice AI for Restaurants
                </h1>
                <p className="text-white text-base md:text-xl">Introducing Hirekarigar's AI Captains</p>
                <p className="text-white text-sm md:text-base">
                  Elevate your restaurant service with our AI-based captains. Designed to assist during rush hours, our AI captains streamline your
                  operations and enhance customer satisfactions for your restaurants , to help you solve your hiring needs during rush hours.
                </p>
              </div>
              <div className="flex justify-center items-center gap-4">
                <a
                  href="https://api.whatsapp.com/send/?phone=917581950924&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noreferrer"
                  className="flex group items-center gap-2.5 hover:text-white font-semibold text-lg hover:bg-[rgba(255,255,255,0.05)] bg-white border border-solid border-white text-black rounded-full py-2 px-5 transition-all duration-200 ease-in"
                >
                  Get in touch
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16.2477 13.4907H5.09766C4.81432 13.4907 4.57682 13.3949 4.38516 13.2032C4.19349 13.0116 4.09766 12.7741 4.09766 12.4907C4.09766 12.2074 4.19349 11.9699 4.38516 11.7782C4.57682 11.5866 4.81432 11.4907 5.09766 11.4907H16.2477L13.3977 8.64073C13.1977 8.44073 13.1018 8.2074 13.1102 7.94073C13.1185 7.67407 13.2143 7.44073 13.3977 7.24073C13.5977 7.04073 13.8352 6.93657 14.1102 6.92823C14.3852 6.9199 14.6227 7.01573 14.8227 7.21573L19.3977 11.7907C19.4977 11.8907 19.5685 11.9991 19.6102 12.1157C19.6518 12.2324 19.6727 12.3574 19.6727 12.4907C19.6727 12.6241 19.6518 12.7491 19.6102 12.8657C19.5685 12.9824 19.4977 13.0907 19.3977 13.1907L14.8227 17.7657C14.6227 17.9657 14.3852 18.0616 14.1102 18.0532C13.8352 18.0449 13.5977 17.9407 13.3977 17.7407C13.2143 17.5407 13.1185 17.3074 13.1102 17.0407C13.1018 16.7741 13.1977 16.5407 13.3977 16.3407L16.2477 13.4907Z"
                      className="group-hover:fill-white"
                      fill="black"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </>
        )}
      </section>

      {showPublicKeyInvalidMessage ? <PleaseSetYourPublicKeyMessage /> : null}
    </div>
  );
};

const usePublicKeyInvalid = () => {
  const [showPublicKeyInvalidMessage, setShowPublicKeyInvalidMessage] = useState(false);

  // close public key invalid message after delay
  useEffect(() => {
    if (showPublicKeyInvalidMessage) {
      setTimeout(() => {
        setShowPublicKeyInvalidMessage(false);
      }, 3000);
    }
  }, [showPublicKeyInvalidMessage]);

  return {
    showPublicKeyInvalidMessage,
    setShowPublicKeyInvalidMessage,
  };
};

const PleaseSetYourPublicKeyMessage = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: "25px",
        left: "25px",
        padding: "10px",
        color: "#fff",
        backgroundColor: "#f03e3e",
        borderRadius: "5px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
      }}
    >
      Is your Vapi Public Key missing? (recheck your code)
    </div>
  );
};

export default Rastaurant;
